import React from 'react';
import Table from 'react-bootstrap/Table';

export default function DATable({ rows, data }) {
  const repr = (val) => Number.isNaN(val) || val === undefined || val === null ? '--' : val;

  function getColor(value) {
    if (value >= 1) {
      return 'green';
    } else if (value <= (-1)) {
      return 'red';
    } else if (value < 1 && value > -1) {
      return 'yellow';
    } 
    return '';
  }

  function NumberCell({ value, columnName, rowName }) {
    let color;

    if (columnName === 'Balance (kg/ha)' && ['N', 'P', 'S', 'K', 'Mg', 'Ca'].includes(rowName)) {
      color = getColor(Number(value));
    }

    return <td className={`da-table-${color}`}>{value}</td>;
  }

  // Renderizado flexible que admite objetos { colSpan, content } o JSX
  const renderCell = (val, colIdx, headerRow, row) => {
    // celda especial con colSpan y contenido
    if (val && typeof val === 'object' && 'colSpan' in val && 'content' in val) {
      return (
        <td key={colIdx} colSpan={val.colSpan}>
          {val.content}
        </td>
      );
    }

    // valor JSX válido
    if (React.isValidElement(val)) {
      return <td key={colIdx}>{val}</td>;
    }

    // número o texto
    const isNumeric = typeof val === 'number' && !isNaN(val);
    return (
      <NumberCell
        key={colIdx}
        value={isNumeric ? val.toFixed(2) : repr(val)}
        rowName={row[headerRow.indexOf('Elemento')]}
        columnName={headerRow[colIdx]}
        requirement={row[headerRow.indexOf('Requerimientos (kg/ha)')]}
        availability={row[headerRow.indexOf('Disponibilidad (kg/ha)')]}
        aportes={row[headerRow.indexOf('Aporte (kg/ha)')]}
      />
    );
  };

  if (!rows || rows.length === 0) return null;
  const headerRow = rows[0];

  return (
    <Table responsive className='table-modern align-middle'>
      <thead>
        <tr>
          {headerRow.map((val, idx) => (
            <th key={idx}>{val}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {rows.slice(1).map((row, idx) => (
          <tr key={idx}>
            {row.map((val, colIdx) => renderCell(val, colIdx, headerRow, row))}
          </tr>
        ))}
      </tbody>
    </Table>
  );
}